import { Stack, Text, useText } from "@sveabank/cc-common";
import { Images } from "../../images";

const getImage = (packageId: string | null) => {
	switch (packageId) {
		case "FÖRETAGARNA-BAS":
		case "FORETAGARNA-CARDONLY":
			return Images.FORETAGARNA_DASHBOARD;
		case "BAAS-FÖRETAG-VÄXA":
			return Images.GROW;
		case "BAAS-FÖRETAG-BAS":
			return Images.BAS;
		case "E-HANDEL-BAS":
			return Images.EHANDEL;
		default:
			return null;
	}
};

const PreselectedPackageInfobox = () => {
	const [t, texts] = useText();

	type PreselectedText = typeof texts.dashboardPage.preselectedPackage;
	const preSelectedId = sessionStorage.getItem("preSelectedPackage");
	const text = texts.dashboardPage.preselectedPackage[preSelectedId as keyof PreselectedText];
	const bgColor =
		preSelectedId === "FÖRETAGARNA-BAS" || preSelectedId === "FORETAGARNA-CARDONLY"
			? "bg-background-foretagarna"
			: "bg-background-dark";

	if (!preSelectedId || !text) return null;

	const image = getImage(preSelectedId);

	return (
		<div className={`${bgColor} p-6 max-md:-mx-4`}>
			<div className="tablet:grid-cols-2 grid w-full grid-cols-1 gap-4">
				<div className="max-tablet:order-2 justify-self-start">
					<Stack gap={6}>
						<Text component="h4" bold className="text-text-contrast text-xl">
							{t(text.title)}
						</Text>

						<Text className="text-text-contrast">{t(text.description)}</Text>

						<ul className="text-text-contrast list-disc pl-5 text-left">
							<li>{t(text.text1)}</li>
							<li>{t(text.text2)}</li>
						</ul>
					</Stack>
				</div>

				{image && (
					<div className="max-tablet:order-1 tablet:justify-self-end justify-self-center">
						<img
							alt={t(text.title)}
							className="tablet:max-h-55 h-auto w-full self-start rounded-lg object-contain drop-shadow-xs"
							src={image}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

export default PreselectedPackageInfobox;
